interface LoadingSpinnerProps {
  label?: string;
  compact?: boolean;
}

function LoadingSpinner({ compact = false, label = "Cargando..." }: LoadingSpinnerProps) {
  return (
    <div className={`spinner-box ${compact ? "compact" : ""}`} role="status" aria-live="polite">
      <span className="spinner" />
      <span>{label}</span>
    </div>
  );
}

export default LoadingSpinner;
